import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import handleRequestError from '../../utils/handleRequestError';

const initialState = {
  isLoading: true,
  data: {
    headers: {},
    values: [],
  },
  filters: {
    startdate: null,
    enddate: null,
    userid: null,
    companyid: null,
    locationid: '',
  },
  error: '',
};

export const fetchHRPayroll = createAsyncThunk(
  'hrPayroll/fetchHRPayroll',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/workingmapworkers/payroll`, {
        params,
      });

      return response.data.data;
    } catch (err) {
      return handleRequestError(err, rejectWithValue);
    }
  }
);

const hrPayrollSlice = createSlice({
  name: 'hrPayrollSlice',
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters(state) {
      state.filters = {
        ...state.filters,
        userid: null,
        companyid: null,
        locationid: '',
      };
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchHRPayroll.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchHRPayroll.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.error = '';
      state.data = {
        values: payload.data,
        headers: payload.header,
      };
    });
    builder.addCase(fetchHRPayroll.rejected, (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    });
  },
});

export const { setFilters, resetFilters } = hrPayrollSlice.actions;

export default hrPayrollSlice.reducer;

export const selectHRPayrollFilters = (state) => state.hrPayroll.filters;
export const selectHRPayrollData = (state) => state.hrPayroll.data;
export const selectHRPayrollLoading = (state) => state.hrPayroll.isLoading;
export const selectHRPayrollError = (state) => state.hrPayroll.error;
